import {FacialVerification} from 'components/Compliance/NRB/FacialVerification';

export const NrbFacialVerification = () => <FacialVerification />;
